$(document).ready(function() {

  const state = {
    email: '',
    subjects: [],
    isSample: false,
  }

  const serialize = function(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p) && obj[p] !== '') {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  const enableButton = function() {
    $('.js-q-next').removeClass('disabled');
  }

  const disableButton = function() {
    $('.js-q-next').addClass('disabled');
  }

  const loadQuiz = function() {
    window.location.href = $('input[name="quizStartUrl"]').val() + '?' + serialize(state);
  }

  // RFC2822 conform regex - additionally server checks if email is registered in HS
  const validateEmail = function() {
    if (/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(state.email)) {
      return (true)
    }

    return (false)
  }

  const showSubjectSelection = function() {
    $('.js-btn-container').hide();
    $('.js-q-index-body').hide().text($('input[name="selectSubjectText"]').val()).fadeIn();
    $('.quiz-content .content-container .input-container').addClass('show');
    $('.js-q-email').removeClass('show');
    //setTimeout(function() {
      $('.js-btn-container').show();
    //}, 500);
  }

  $('.js-q-next').on('click tap', function(evt) {
    evt.preventDefault();
    disableButton();
    if (!state.subjects.length > 0) {
      showSubjectSelection();
    } else {
      loadQuiz();
    }

    return false;
  })

  $('.js-q-email').on('keyup keypress blur change', function() {
    state.email = $(this).val();
    if (validateEmail()) {
      enableButton();
    } else {
      disableButton();
    }
  });

  $('.js-subject').on('click tap', function() {
    const val = $(this).data('value');
    var subjects = state.subjects;
    if ($(this).hasClass('selected')) {
      subjects = jQuery.grep(subjects, function(value) {
        return value != val;
      });
      $(this).removeClass('selected');
    } else {
      $(this).addClass('selected');
      subjects.push(val);
    }

    if (subjects.length > 0 ) {
      enableButton();
    } else {
      disableButton();
    }

    state.subjects = subjects;

  })

  const passedEmail = $('input[name="passedEmail"]').val();
  const isSample = $('input[name="isSample"]').val() == 'true';
  const passedSubjects = $('input[name="passedSubjects"]').val();
  const additionalSubjects = $('input[name="additionalSubjects"]').val();
  if (additionalSubjects) {
    state.additionalSubjects = additionalSubjects
  }

  if (isSample || passedEmail) {
    state.isSample = isSample;
    state.email = passedEmail;
    showSubjectSelection();
  }

  if (passedSubjects) {
    state.subjects = passedSubjects.split(',');
  }

});
